import { render, staticRenderFns } from "./NewContactAndConversation.vue?vue&type=template&id=5d72b406&"
import script from "./NewContactAndConversation.vue?vue&type=script&lang=js&"
export * from "./NewContactAndConversation.vue?vue&type=script&lang=js&"
import style0 from "./NewContactAndConversation.vue?vue&type=style&index=0&id=5d72b406&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports